<template>
    <svg width="27px" height="16px" viewBox="0 0 27 16" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg">
        <g id="iconVideo" transform="translate(-3 -8)">
            <path
                d="M7 8L18 8C20.209 8 22 9.791 22 12L22 20C22 22.209 20.209 24 18 24L7 24C4.791 24 3 22.209 3 20L3 12C3 9.791 4.791 8 7 8ZM24.504 18.2886C24.192 18.1096 24 17.7786 24 17.4196L24 14.5806C24 14.2216 24.192 13.8906 24.504 13.7116L28.504 10.8546C29.17 10.4746 30 10.9556 30 11.7236L30 20.2766C30 21.0446 29.17 21.5256 28.504 21.1446L24.504 18.2886Z"
                id="Video" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>